var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"checkbox",class:((_vm.active ? 'active' : '') + " " + _vm.color + " " + (_vm.disable ? 'disable' : '')),on:{"click":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }